<template>
    <div class="toggle-container">
        <button class="btn m-1"
                v-for="x in ownVal"
                :class="x.active ? 'active' : ''"
                @click="onClick(x)">
            {{ x.name }}
        </button>
    </div>
</template>

<script>
  export default {
    name: 'CoddinToggle',
    props: {
      val: {
        type: Array,
      },
    },
    data() {
      return {
        ownVal: this.val.map((x) => {
          return {name: x, active: false}
        })
      }
    },
    methods: {
      onClick(val) {
        this.ownVal.forEach((x) => {
          x.active = false;
        });
        val.active = true;
        this.$emit('codd_input', this.ownVal)
      }
    },
  }
</script>

<style lang="scss">
    .toggle-container {
        display: flex;
        align-items: center;
        margin: 0 auto;
    }

    .btn {

        &.active {
            color: white;
            background-color: #3DB0C7;
        }
        &:focus {
            outline: 0;
            box-shadow: none;
        }
    }
</style>
